/* Resinify Technology — global.js
   Minimal, dependency-free. Menu drawer, product variant picker,
   quantity controls, gallery thumbnails, product recommendations. */

(function () {
  'use strict';

  /* ---------- Mobile menu drawer ---------- */
  document.querySelectorAll('[data-menu-toggle]').forEach(function (toggle) {
    var drawer = document.getElementById(toggle.getAttribute('aria-controls'));
    if (!drawer) return;
    function setOpen(open) {
      drawer.setAttribute('data-open', open ? 'true' : 'false');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) {
        var first = drawer.querySelector('a, button');
        if (first) first.focus();
      } else {
        toggle.focus();
      }
    }
    toggle.addEventListener('click', function () {
      setOpen(drawer.getAttribute('data-open') !== 'true');
    });
    drawer.addEventListener('click', function (e) {
      if (e.target.closest('[data-menu-close]')) setOpen(false);
    });
    drawer.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') setOpen(false);
    });
  });

  /* ---------- Quantity inputs ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-change]');
    if (!btn) return;
    var wrap = btn.closest('.qty-input');
    var input = wrap && wrap.querySelector('input');
    if (!input) return;
    var step = parseInt(btn.getAttribute('data-qty-change'), 10) || 0;
    var min = parseInt(input.min, 10) || 1;
    var next = (parseInt(input.value, 10) || min) + step;
    input.value = Math.max(min, next);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Product gallery thumbnails ---------- */
  document.querySelectorAll('[data-product-gallery]').forEach(function (gallery) {
    var main = gallery.querySelector('[data-gallery-main] img');
    gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        if (!main) return;
        var src = thumb.getAttribute('data-src');
        var srcset = thumb.getAttribute('data-srcset');
        var alt = thumb.getAttribute('data-alt') || '';
        if (src) main.src = src;
        if (srcset) main.srcset = srcset;
        main.alt = alt;
        gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
          t.removeAttribute('aria-current');
        });
        thumb.setAttribute('aria-current', 'true');
      });
    });
  });

  /* ---------- Variant picker ---------- */
  document.querySelectorAll('[data-product-form]').forEach(function (root) {
    var jsonEl = root.querySelector('[data-product-json]');
    if (!jsonEl) return;
    var product;
    try { product = JSON.parse(jsonEl.textContent); } catch (err) { return; }

    var idInput = root.querySelector('input[name="id"]');
    var priceEl = root.querySelector('[data-price]');
    var compareEl = root.querySelector('[data-compare-price]');
    var availEl = root.querySelector('[data-availability]');
    var addBtn = root.querySelector('[data-add-to-cart]');
    var moneyFormat = root.getAttribute('data-money-format') || '${{amount}}';

    function formatMoney(cents) {
      var amount = (cents / 100).toFixed(2);
      return moneyFormat.replace(/\{\{\s*amount\s*\}\}/, amount);
    }

    function selectedOptions() {
      var opts = [];
      root.querySelectorAll('.variant-fieldset').forEach(function (fs) {
        var checked = fs.querySelector('input:checked');
        opts.push(checked ? checked.value : null);
      });
      return opts;
    }

    function findVariant(opts) {
      return product.variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
    }

    function update() {
      var variant = findVariant(selectedOptions());
      if (!variant) {
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = addBtn.getAttribute('data-text-unavailable') || 'Unavailable'; }
        if (availEl) { availEl.hidden = true; }
        return;
      }
      if (idInput) idInput.value = variant.id;
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.hidden = false;
          compareEl.querySelector('s').textContent = formatMoney(variant.compare_at_price);
        } else {
          compareEl.hidden = true;
        }
      }
      if (availEl) {
        availEl.hidden = false;
        if (variant.available) {
          availEl.classList.add('availability--in');
          availEl.classList.remove('availability--out');
          availEl.textContent = availEl.getAttribute('data-text-in') || 'In stock';
        } else {
          availEl.classList.add('availability--out');
          availEl.classList.remove('availability--in');
          availEl.textContent = availEl.getAttribute('data-text-out') || 'Sold out';
        }
      }
      if (addBtn) {
        addBtn.disabled = !variant.available;
        addBtn.textContent = variant.available
          ? (addBtn.getAttribute('data-text-add') || 'Add to cart')
          : (addBtn.getAttribute('data-text-soldout') || 'Sold out');
      }
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }

    root.addEventListener('change', function (e) {
      if (e.target.matches('.variant-option input')) update();
    });
    update();
  });

  /* ---------- Product recommendations ---------- */
  document.querySelectorAll('[data-recommendations]').forEach(function (holder) {
    var url = holder.getAttribute('data-url');
    if (!url) return;
    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var inner = doc.querySelector('[data-recommendations-inner]');
        if (inner && inner.children.length > 0) {
          holder.innerHTML = inner.outerHTML;
        } else {
          var section = holder.closest('.section');
          if (section) section.hidden = true;
        }
      })
      .catch(function () { /* silently skip */ });
  });
})();

/* ---------- Analytics hooks (GA4 / Ads / Meta ready — no vendor IDs) ----------
   Elements with [data-track] push a normalized event to window.dataLayer.
   Connect GA4/Google Ads via GTM, or Meta Pixel by listening to these events. */
(function () {
  'use strict';
  window.dataLayer = window.dataLayer || [];
  document.addEventListener('click', function (e) {
    var el = e.target.closest('[data-track]');
    if (!el) return;
    var payload = { event: 'resinify_' + el.getAttribute('data-track').replace(/-/g, '_') };
    ['product-title', 'doc-kind', 'doc-name', 'collection', 'cta'].forEach(function (attr) {
      var v = el.getAttribute('data-' + attr);
      if (v) payload[attr.replace(/-/g, '_')] = v;
    });
    window.dataLayer.push(payload);
  }, { capture: true });
})();
